
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"124","height":"124","fill":"#400F3F","rx":"16"}}),_c('path',{attrs:{"fill":"#FF4702","d":"M80.127 50.04l2.922-2.92a1.29 1.29 0 000-1.808l-1.836-1.835a1.296 1.296 0 00-1.836 0l-2.87 3.023a23.309 23.309 0 00-9.31-4.573V38.75a2.584 2.584 0 00-2.586-2.583h-5.173a2.584 2.584 0 00-2.586 2.583v3.177c-10.585 2.41-18.096 11.811-18.102 22.656.141 12.523 10.075 22.742 22.602 23.25a23.277 23.277 0 0021.472-12.906 23.232 23.232 0 00-2.697-24.888zM62.024 82.666c-9.997 0-18.102-8.097-18.102-18.084S52.027 46.5 62.024 46.5c9.998 0 18.103 8.096 18.103 18.083 0 9.987-8.105 18.084-18.103 18.084zm1.5-31a1.32 1.32 0 00-1.5 1.291v11.625l8.172 8.164a1.323 1.323 0 001.966-.13 12.905 12.905 0 001.894-13.031 12.93 12.93 0 00-10.532-7.92z"}})])])
          )
        }
      }
    